import signupReducer from './signup';
import generalReducer from './general';

const reducers = {
  signup: signupReducer,
  general: generalReducer,
};

export default reducers;
